export default __webpack_public_path__ + "static/media/modalIcon.bae0c3fc.svg";